import { Component, Input } from '@angular/core';
import { getDateString } from '@ptg-shared/utils/string.util';

@Component({
  selector: 'ptg-datetime-column',
  templateUrl: './datetime-column.component.html',
  styleUrls: ['./datetime-column.component.scss'],
})
export class DatetimeColumnComponent {
  readonly getDateString = getDateString;
  
  @Input() value!: string;
  @Input() format: string = 'MM/dd/yyyy';
  @Input() emptyString!: string;
  @Input() keepLocalTime?: boolean = false;
}
